import React from 'react';

const KEY = 'bedashboard:work:column-order';

type TypeOrder = Record<string, string[]>;

const read = (): TypeOrder => {
    try {
        const raw = window.localStorage.getItem(KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? (parsed as TypeOrder) : {};
    } catch {
        return {};
    }
};

let state: TypeOrder = read();

const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
};

const snapshot = () => state;

export function setColumnOrder(viewId: string, ids: string[]): void {
    state = { ...state, [viewId]: ids };

    try {
        window.localStorage.setItem(KEY, JSON.stringify(state));
    } catch {
    }

    listeners.forEach((listener) => listener());
}

export const useColumnOrder = (): TypeOrder => React.useSyncExternalStore(subscribe, snapshot, snapshot);
